<template>
  <v-dialog
      v-model="show"
      persistent
      width="500"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Изменить Telegram</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12">
<!--            todo disable после отправки-->
            <v-alert
                  class="mt-3"
                  border="left"
                  colored-border
                  color="warning"
                  elevation="2"
                >
                Для получения кода подтверждения через телеграм бота добавьте бота (<a href="https://t.me/oline_auth_bot" target="_blank">@oline_auth_bot</a>) и впишите свой Telegram Chat ID
            </v-alert>
            <v-btn
                v-if="currentUser.tg_chat_id"
                block
                class="my-4"
                color="green"
                @click="codeRequest"
                depressed
                outlined
            >
              Отправить код подтверждения
            </v-btn>
            <v-text-field
                v-if="currentUser.tg_chat_id"
                label="Код подтверждения"
                type="text"
                v-model="code"
                required
            ></v-text-field>

            <v-text-field
                label="Новый Telegram ID"
                type="text"
                v-model="tg_chat_id"
                required
            ></v-text-field>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            variant="text"
            @click="show = false"
        >
          Отменить
        </v-btn>
        <v-btn
            depressed
            outlined
            variant="text"
            @click="update"
        >
          Обновить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ChangeTelegramDialog",
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      code: null,
      tg_chat_id: null,
    }
  },

  watch: {
    show(val) {
      if (!val) {
        this.clear();
      }
    },
  },

  computed: {
    ...mapGetters('user', ['currentUser']),
    show: {
      get() {
        return this.value;
      },

      set(show) {
        this.$emit('input', show);
      }
    },

    payload() {
      return {
        code: this.code,
        tg_chat_id: this.tg_chat_id,
      }
    },
  },

  methods: {
    ...mapActions({
      sendCodeRequest: 'user/sendCodeRequest',
      changeTelegram: 'user/changeTelegram',
    }),

    clear() {
      this.code = null;
      this.tg_chat_id = null;
    },

    update() {
      this.changeTelegram(this.payload)
          .then(() => {
            this.show = false;
          });
    },

    codeRequest() {
      this.sendCodeRequest('telegram');
    },
  },
}
</script>

<style scoped>

</style>